import React from 'react';
import { FormattedMessage } from 'react-intl';

import { NewQuoteButton } from '../../pages/ltl-freight/components/freight-action-buttons/new-quote-button';
import { TrackFreightButton } from '../../pages/ltl-freight/components/freight-action-buttons/track-freight-button';
import { PrintFreightButton } from '../../pages/ltl-freight/components/freight-action-buttons/print-freight-button';
import { CancelFreightButton } from '../../pages/ltl-freight/components/freight-action-buttons/cancel-freight-button';

import {
  FREIGHT_VIEW_ID,
  FREIGHT_PENDING_QUOTES_VIEW_ID,
  FREIGHT_BOOKED_VIEW_ID,
  FREIGHT_CANCELLED_VIEW_ID,
} from './freight-view-constants';

export const freightView = {
  label: <FormattedMessage defaultMessage='LTL' description='Left nav label for the LTL freight page' id='SeGtdC' />,
  id: FREIGHT_VIEW_ID,
  navigationOverride: '/freight/ltl',
  buttons: [
    <NewQuoteButton key='newQuote' />,
    <TrackFreightButton key='trackFreight' />,
    <PrintFreightButton key='printFreight' />,
    <CancelFreightButton key='cancelFreight' />,
  ],
};

export const freightPendingQuotesView = {
  label: <FormattedMessage defaultMessage='Pending Quotes' description='Left nav label for freight pending quotes sub-view' id='QfQy3m' />,
  id: FREIGHT_PENDING_QUOTES_VIEW_ID,
  navigationOverride: '/freight/ltl/pending-quotes',
  parentId: FREIGHT_VIEW_ID,
};

export const freightBookedView = {
  label: <FormattedMessage defaultMessage='Booked' description='Left nav label for freight booked sub-view' id='BPY21z' />,
  id: FREIGHT_BOOKED_VIEW_ID,
  navigationOverride: '/freight/ltl/booked',
  parentId: FREIGHT_VIEW_ID,
};

export const freightCancelledView = {
  label: <FormattedMessage defaultMessage='Cancelled' description='Left nav label for freight cancelled sub-view' id='tn/wr0' />,
  id: FREIGHT_CANCELLED_VIEW_ID,
  navigationOverride: '/freight/ltl/cancelled',
  parentId: FREIGHT_VIEW_ID,
};

export const allFreightViews = [freightView, freightPendingQuotesView, freightBookedView, freightCancelledView];

export default freightView;
